/* eslint-disable react/require-default-props */
import React from 'react';
import PropTypes from 'prop-types';
import { Accordion, Card } from 'react-bootstrap';
import { useAccordionButton } from 'react-bootstrap/AccordionButton';

function CustomToggle({ children, eventKey, append, isExpanded, small }) {
  const decoratedOnClick = useAccordionButton(eventKey);

  return (
    <div className="d-flex">
      <div className="me-auto d-flex align-items-center">
        <h4 className={`ttl m-0${small ? ' text-reg' : ''}`}>{children}</h4>
      </div>
      <div className="ms-auto d-flex align-items-center">
        {append}
        <button
          className="toggle m-1"
          type="button"
          onClick={decoratedOnClick}
          aria-label={isExpanded ? 'Collapse section' : 'Expand section'}
        >
          <i
            className={`text-primary fas fa-${isExpanded ? 'minus' : 'plus'}${
              !small ? ' text-lg' : ''
            }`}
          />
        </button>
      </div>
    </div>
  );
}

function AccordionItem({
  className,
  children,
  eventKey,
  label,
  expanded,
  onSetExpanded,
  append,
  itemRef,
  small,
  p4,
}) {
  const isExpanded =
    expanded instanceof Array ? expanded.includes(eventKey) : expanded === eventKey;

  return (
    <Card className={className}>
      <Card.Header
        className={`${small ? 'px-3 py-1' : 'px-4 py-3'}${
          isExpanded ? ' active' : ' rounded-br border-bottom-0 rounded-bl'
        } border-bottom-0`}
        ref={itemRef}
        onClick={() => onSetExpanded(eventKey)}
      >
        <CustomToggle eventKey={eventKey} isExpanded={isExpanded} append={append} small={small}>
          {label}
        </CustomToggle>
      </Card.Header>
      <Accordion.Collapse eventKey={eventKey}>
        <Card.Body className={p4 ? 'p-4' : 'p-0'}>{children}</Card.Body>
      </Accordion.Collapse>
    </Card>
  );
}

AccordionItem.propTypes = {
  /**
   * The unique key per item.
   */
  eventKey: PropTypes.number,
  /**
   * Whether the item is expanded, or not.
   */
  expanded: PropTypes.oneOfType([PropTypes.number.isRequired, PropTypes.array.isRequired]),
  /**
   * The function to be called after the item is expanded.
   */
  onSetExpanded: PropTypes.func.isRequired,
  /**
   * The label.
   */
  label: PropTypes.oneOfType([
    PropTypes.string.isRequired,
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
};

export default AccordionItem;
